
import React from 'react';
import CookieConsentBanner from './CookieConsentBanner';
import CookieSettingsModal from './CookieSettingsModal';

const CookieConsent: React.FC = () => {
  return (
    <>
      <CookieConsentBanner />
      <CookieSettingsModal />
    </>
  );
};

export default CookieConsent;
